import React from "react"
import { graphql, Link } from "gatsby"
import { Helmet } from "react-helmet"

import SEO from "../components/seo"
import Layout from "../modules/layout"
import Breadcrumbs from "../modules/breadcrumbs"
import SecondNav from "../modules/secondNav"
import Hero from "../modules/hero"
import PageBuilder from "../components/page-builder"
import { linkFormat } from "../helpers/links"

export const query = graphql`
  query($slug: String) {
    sanityPage(slug: { current: { eq: $slug } }) {
      title
      slug {
        current
      }
      secondaryNav {
        structure {
          url
          title
          bold
          before
          _key
        }
      }
      _rawHero(resolveReferences: { maxDepth: 10 })
      _rawContent(resolveReferences: { maxDepth: 10 })
      seo {
        metaTitle
        canonical
        description
        noIndex
        openGraphImage {
          asset {
            url
          }
        }
      }
    }
  }
`

export default props => {
  const page = props.data.sanityPage
  const title = page.title
  const customTitle = page.seo && page.seo.metaTitle ? page.seo.metaTitle : null
  const description = page.seo ? page.seo.description : null
  const image =
    page.seo &&
    page.seo.openGraphImage &&
    page.seo.openGraphImage.asset !== null
      ? page.seo.openGraphImage.asset.url
      : null
  return (
    <>
      <Layout>
        <Helmet>
          {page.seo && page.seo.noIndex && (
            <meta name="robots" content="noindex" />
          )}
        </Helmet>
        <SEO
          title={title}
          description={description}
          image={image}
          customTitle={customTitle}
        />
        {page.secondaryNav && (
          <>
            <Breadcrumbs alt location={props.location}>
              {page.secondaryNav.structure.map(item => (
                <Link
                  key={item._key}
                  state={{ bold: !!item.bold, before: !!item.before }}
                  to={linkFormat(item.url)}
                >
                  {item.title}
                </Link>
              ))}
            </Breadcrumbs>
            <SecondNav nav={page.secondaryNav.structure}>
              {page.secondaryNav.structure[0].title}
            </SecondNav>
          </>
        )}
        {page._rawHero && (
          <Hero
            {...page._rawHero}
            tagline={page._rawHero.tagline}
            ctas={page._rawHero.ctas}
          />
        )}
        {page._rawContent && <PageBuilder blocks={page._rawContent} />}
      </Layout>
    </>
  )
}
